// Env naming varies across teams (prd/prod/production). All three are
// first-class so prod guardrails never silently miss due to naming convention.
export function isProdEnv(env: string): boolean {
  return /^(prd|prod|production)$/i.test(env)
}
